
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91participant_939CwHwc_457D64Q2X_45xrlUBn1eCxIKxgrX4QIuiZCOPaDAMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/form/[event]/participant/[participant].vue?macro=true";
import { default as _91event_93CFLVNOTdGCs_45jkj3NCqzbLC3nmG_45Td5UAm_45PybyXPcQMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/form/[event].vue?macro=true";
import { default as _91signature_93Lnv2RT_qMLj75nff_mn4mAy4hs8VBiwPl2wal_oAAroMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/form/signatures/[signature].vue?macro=true";
import { default as formz0JcYY0R2eL7kLq78_45tlyCal3WqkT6TgHB3_457Rk05zoMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/form.vue?macro=true";
import { default as indexbtgi_45_zV4BUF2b7DTXyEwcqFv6djCp53Djyj5A5r2X8Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/index.vue?macro=true";
import { default as mailBaseDatafPZJhbp5INn58edZ_cg1OSXUeMfRu4_q1ogXZibP9h8Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/mails/[id]/mailBaseData.vue?macro=true";
import { default as mailActivitiesccjxwgQRUKUYAVD5B1Tn2zA6OpFV_piDE3mVX_45wcUhcMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/mails/[id]/mailActivities.vue?macro=true";
import { default as _91id_93h0KBx44d3Uz8aHvi6Nq2fVg0qci3Yfaf_P_s5GS5sI4Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/mails/[id].vue?macro=true";
import { default as indexwhRCpMD5vVa47pjvCRb92JEJ_DB9NY1ZHd9VdxOl7xkMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/mails/index.vue?macro=true";
import { default as mails9X_teBnemeUxaFtFZeYJfKbBWZCSuIPHTJEyWb3dWFUMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/mails.vue?macro=true";
import { default as eventMails76oc1wWMbIp8gWt5V3tiJO_45JMPW87_WEgcy2Gzh4hjAMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[id]/eventMails.vue?macro=true";
import { default as eventLeaders1ecPvX8MOrSt4O9bsS4oVda3XylmjZsKKWBrJEYFiWYMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[id]/eventLeaders.vue?macro=true";
import { default as eventBaseDatajji0oQ6yMRh_452K8xjI_JS0bxDbfBSi4GjKw5CuLzjiMMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[id]/eventBaseData.vue?macro=true";
import { default as eventQuestions54I97uThUr3NPWhsaQwQBIFebrhKorGjTO3S86odSqMMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[id]/eventQuestions.vue?macro=true";
import { default as eventActivitiesOqPN5hHNFF98JQiGlEtWWALDgKDaL_bIEKuyE6utYHMMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[id]/eventActivities.vue?macro=true";
import { default as eventParticipantsvFzOlyjOCN_ZmTyk5L_45Ioh8bwhhWQypnGydIxMDNbNwMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[id]/eventParticipants.vue?macro=true";
import { default as eventCrisisManagersa_lyTOmPgIOW6jLABk3g9tQFlztr6JVqw1UgPne8zMYMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[id]/eventCrisisManagers.vue?macro=true";
import { default as eventParticipantGroupsICZSUS9M82WBhIb6OwbucDMQosueYJCdulwVh5C3nEQMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[id]/eventParticipantGroups.vue?macro=true";
import { default as eventTemporaryAccessesipiutyD4eArLfZDeAADTD3kOJTXXt6C4_45OkmvAfvvXIMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[id]/eventTemporaryAccesses.vue?macro=true";
import { default as _91id_93Aa6dFG6NbYU11F5DTUIgpkwZa_SFq0zlBFOiLhqRPk8Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[id].vue?macro=true";
import { default as indexCinxI_IFPgDsusm9rxv2_OL6d7cecTLtmxHdYQmdZC0Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/index.vue?macro=true";
import { default as participantMailst4pqzITy6I_5cTSYTml_458XRYwTZDqqJa1vFoZaRVj7YMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participants/[id]/participantMails.vue?macro=true";
import { default as participantAnswersuY4UR3DoA7Z2kxo6_45lgMtQmrR3FAUEQ0REatx78x01QMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participants/[id]/participantAnswers.vue?macro=true";
import { default as participantBaseData8oZGmdQK6mUP71_D5LsHWQJNYcYGwm7iHISB5GmBCdgMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participants/[id]/participantBaseData.vue?macro=true";
import { default as participantGuardians_45qKpvKzat05OyDyEUv2miOpZZ0Cb8UFVQ7fbx4DHzwcMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participants/[id]/participantGuardians.vue?macro=true";
import { default as participantActivitiesGnrwkcieb7wVMrrtDEu7whxcK5rCPOHdbWkz_45g0YNskMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participants/[id]/participantActivities.vue?macro=true";
import { default as participantSubmissionsey_2Fd6Us2_lWy_45s3mkZATPPSEqLCVuIFBCtqV9qGHMMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participants/[id]/participantSubmissions.vue?macro=true";
import { default as participantEmergencyContactsKI_45DfplerAWx9Tzbh6rb7QE6R8WeNowThz3E0m02scMMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participants/[id]/participantEmergencyContacts.vue?macro=true";
import { default as participantTemporaryAccessesL_6sL817xdTq3F3Uciw7zKg0Se5b1DE5AZyT_JC9GPIMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participants/[id]/participantTemporaryAccesses.vue?macro=true";
import { default as _91id_93C_45UwS_45QpaOpS5ruAwkOQ3gAN5todyQRgOM1__k806HYMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participants/[id].vue?macro=true";
import { default as groupBaseDatabG3IKa6jZzUv4EMFuZ2zqakI_45vDQ_uW1seyCDAhjxgoMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participantGroups/[id]/groupBaseData.vue?macro=true";
import { default as groupActivitiesLBGbf8SNT5qKMpoqlim6WdzgnpFaakGc51UXr3l7zZkMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participantGroups/[id]/groupActivities.vue?macro=true";
import { default as groupParticipantsZcC0lRDo26jBCc1mmkjw0Z_EgaI54exm5OS_45uCr42egMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participantGroups/[id]/groupParticipants.vue?macro=true";
import { default as groupTemporaryAccessesHFYCeCC_iBHUjt20ujdeV6G9ra_tefHpSsR7J6WE6nAMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participantGroups/[id]/groupTemporaryAccesses.vue?macro=true";
import { default as _91id_937RZ3iDQaj1k_uiQJWzMdFPNBYPAEjfoomOsYNqgudBUMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participantGroups/[id].vue?macro=true";
import { default as eventsWS_JVNdfJM89Z5rpGhcBYPMlazf1kuatRuUkMIugqqoMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events.vue?macro=true";
import { default as rolesfoIZ5Lvz8TBOVgTpMe5Au53ezlvvXXSDbslIMiWtzmQMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/roles.vue?macro=true";
import { default as userBaseDataXwkaA_USTQTxF44xpbefSE9mnkhyty6k0KrSLZ9uwB8Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/users/[id]/userBaseData.vue?macro=true";
import { default as userActivitiesJOgqa4HJdcTlvmBkWqZgE92dp5bM2DDtP21OFn0dK9EMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/users/[id]/userActivities.vue?macro=true";
import { default as _91id_93g97BpepD1PWrXBOfHmruPH81zvq9_45SaKJjU_45Z_95toEMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/users/[id].vue?macro=true";
import { default as indexSrs1oj0emoDJCn5ZFoZhdXDVfHiJolTJUetQKC_dJtoMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/users/index.vue?macro=true";
import { default as usersxg8V9_45UsQhpGN_2hlCE34uew2Ah5XsYrhP75Tss0HOQMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/users.vue?macro=true";
import { default as baseDataouC2dnUzBJY5WmXKEoMPMpT0xKjPKx35BWpMi0xKwCMMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/baseData.vue?macro=true";
import { default as billingsIA3M6pHZNZn8f44h04mZe5MdrK1QppqTZBKfWE8HAh4Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/billings.vue?macro=true";
import { default as billingRunsBY3p7Ll4qV8R1jI1BNK4yOb97FwQI_45OQoOKbpU2gFNUMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/billingRuns.vue?macro=true";
import { default as organisationUsersbOrxhVIPob_aFpsvgulYVCKILfcnZitClVdxr4fxZ7EMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/organisations/[id]/organisationUsers.vue?macro=true";
import { default as organisationPackagevA2EINXMiBprP_IXGmNn46vpEVvpGZeWbl5jVp3Bel4Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/organisations/[id]/organisationPackage.vue?macro=true";
import { default as organisationBaseData7vZIZ8JJmUR4dkfEN67i1ujZFISpUukVC7e_45cCduVu8Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationActivitiesnlaqAM8Stl_45BW8DVA_45p_gMv6SwFRLgRUKE_45TseCqRCsMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationSystemDataWso4al8BR5z7D__5RZhFV9eiWY71uTBuCmjmwdINk1AMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/organisations/[id]/organisationSystemData.vue?macro=true";
import { default as organisationMailSettingsM5K70V1Af1ny_4519m9XV_g_45Q0TYekVcElwd7ljCJIu28Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/organisations/[id]/organisationMailSettings.vue?macro=true";
import { default as _91id_93LlfFDe1ptFgM4E5QCz2Dq9nu5tUmsNd2I81Eb2BuqRwMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/organisations/[id].vue?macro=true";
import { default as indexClf5sIz13x0aSTIIkoBkWVVJEdeP3CSyAR5C9z4XrEwMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/organisations/index.vue?macro=true";
import { default as organisationskDkHrQTunIxU77IzsB4UwyQs8_45eUgIDUuauUcLq_GUwMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/organisations.vue?macro=true";
import { default as poolQuestionsiPG3tquUoCkrI2KlqLCQXp3bAqHys5mojweukAAyaYwMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/poolQuestions.vue?macro=true";
import { default as indexqK6oROgny9hkkAFA60vK2hIxzC4E7Ciy7Wok5DI3BWUMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/mailTemplates/index.vue?macro=true";
import { default as mailTemplateBaseData_izV5GAQNCMSByBLMrd7dmeu2Dg57k6PGGIqT1aoF_IMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as systemHkGss_8Z2maJ_H3XrR9rLyCNPDEiBF7ylQgT6OQ_djoMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system.vue?macro=true";
import { default as userBaseDatawV_45c_45V3XQUkYA3wEbBpCzPIik_45y5BJZINLQrBtnh_CYMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/internal/users/[id]/userBaseData.vue?macro=true";
import { default as userActivities1yKzGJ2yHI8Cmr5l1BF6euI_45G94PAZmWvIRpO2TSbOEMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/internal/users/[id]/userActivities.vue?macro=true";
import { default as _91id_93u_45XDWqUymO3KftVmRhtAQJbmOMMjD_45Wf775QD7guuoAMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/internal/users/[id].vue?macro=true";
import { default as organisationUsersbEhyzK_r5KhfhhO2mUqaIlmPruzOuAFSLHO24cdR8LEMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/internal/organisation/organisationUsers.vue?macro=true";
import { default as organisationPackageiviq7YpeuFkrP_ol6AxGjzWvz3WCd2lRWzFcZDxYiiAMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/internal/organisation/organisationPackage.vue?macro=true";
import { default as organisationBaseDataGuBDXHtWOzl8dX1nh3_45lgurh2l5vwWOLO0j6tSb2FjEMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/internal/organisation/organisationBaseData.vue?macro=true";
import { default as organisationMailSettingsbUK_45eWJmoXVvg9jHWCqb114JOI6uYxg5cFNzr_vxXycMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/internal/organisation/organisationMailSettings.vue?macro=true";
import { default as organisationgcIEUVnTxeI24Rzsn26b0A_d__45grPunUiSaFnE0WaHMMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/internal/organisation.vue?macro=true";
import { default as mailTemplateBaseDataCeXLyW_45NxrXD7XOZ_45Uv_45Ku3Iz4Rz2HGL35EXJfuTKM8Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/internal/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as internal4cZpUHzvJxQ1QnKvClDPCp8KkBVNmapmnj1nwEF4_isMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/internal.vue?macro=true";
import { default as _91id_93FCbHSe5lt35_doU6LLP71hfnkUdi9OVGgO2_UZFVLhoMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/crisisManagers/[id].vue?macro=true";
import { default as _91id_93QDgw6nuTk1LGmqe1GSwC5EU0TEnZFvjbsg6fbhL_45rXYMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/loginProviders/[id].vue?macro=true";
import { default as index8ewOnFHS00ycc65MMvZuuuriZwiTdEHFbiVFt9dvq1MMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/crisisManagers/index.vue?macro=true";
import { default as indexoWv8BNoDqjoi0f_45fEANzdnMgizdhMFdbbgNUOHTWF3gMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/loginProviders/index.vue?macro=true";
import { default as settingsH8KIscjpvt2T7HxSNXXzVujpyTkZRatKhxUUF1SMXmYMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings.vue?macro=true";
import { default as setBaseDataiInm8HDCUub6FJ18TWTX_kwYNJ97gWL8rfCT2WaHue8Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/questions/sets/[id]/setBaseData.vue?macro=true";
import { default as _91id_93U03W3O8IRR4S4sr205VYRHG9J8_eRUyQzB9BWzp98oMMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/questions/sets/[id].vue?macro=true";
import { default as index59jvQsuM3mFm4LWbojMciI_bXyAB4EhS3I5v_zGKoHkMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/questions/sets/index.vue?macro=true";
import { default as setseJzChSrn3LGQ1obkYSxplG30aPMjOSeMZJ_45hB5lecKMMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/questions/sets.vue?macro=true";
import { default as questions_45DPl2G_ZzIWj2sRS0oMIBZOESq6UaFJGGctgicXpwSYMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/questions.vue?macro=true";
import { default as indexeOowH_45K0IANkZeEcD0nWra_2fwEN6i9mOFqZtidNE1oMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/auth/index.vue?macro=true";
import { default as inputsGL8ovyVMYlf2_YCPyK8YwEA0J36Zfl5xrmI3ek_45_45NxoMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/secret/index/inputs.vue?macro=true";
import { default as mosaicmi2Lwp4fWQI5aTPZTHAiJJ_45vLYj0toW5geenZ4cGa9IMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/secret/index/mosaic.vue?macro=true";
import { default as dungeoneW7zmwhYQWTla8aknCys68rZGcyAiGY3INypfP_45ukQsMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/secret/index/dungeon.vue?macro=true";
import { default as componentsk2Yah_fmvFqlL9vmDHgA8zQfcdoqSHsLoXw9BKfQmh8Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/secret/index/components.vue?macro=true";
import { default as indexem5gpDYR08DOSDM_45OUk8sLjXpFeH74QEqoL3HB_45DfrMMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/secret/index.vue?macro=true";
import { default as registergtRqRIkUSdVcKoPp7NUZbUfRTLT7xr_7HnzHgJ8NGoAMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/auth/register.vue?macro=true";
import { default as _91leader_93fq1IGxdDT_4NgTfY0cFKzT7Yv8yjoQbEwQY_45aTPgu4UMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/external/event/[event]/leader/[leader].vue?macro=true";
import { default as _91emergency_93BgZVzfoFXvAIKTvdeCXXpJcqc8kTLnxmWWa_45ByaG06UMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/external/event/[event]/emergency/[emergency].vue?macro=true";
import { default as _91temporary_93Ia_NaYwW6Fg6Hb0vIzGlLZ0AS6TmAU5TkSgC6LmkzWQMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/external/event/[event]/temporary/[temporary].vue?macro=true";
import { default as _91event_93AOupjrvPqtnD4kbNti5fP8iM5H8grYxgymFPBh9Rz_IMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/external/event/[event].vue?macro=true";
import { default as event1HWwsAsfHKoRZRt12JHR0JwM6PfCa8fKa0wBqdWMEGQMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/external/event.vue?macro=true";
import { default as indexmCLC7o4U2PDdYUM0Jt83OnP_p_45NdGLVubeaczmT4k6MMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/auth/amos/[organisation]/index.vue?macro=true";
import { default as indexID7Ov186M9RDby8IfXZZN0CmKnnjdTkb1hfOS1sO0HIMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/auth/social/[organisation]/index.vue?macro=true";
export default [
  {
    name: "form",
    path: "/form",
    meta: formz0JcYY0R2eL7kLq78_45tlyCal3WqkT6TgHB3_457Rk05zoMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/form.vue"),
    children: [
  {
    name: "form-event",
    path: ":event()",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/form/[event].vue"),
    children: [
  {
    name: "form-event-participant-participant",
    path: "participant/:participant()",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/form/[event]/participant/[participant].vue")
  }
]
  },
  {
    name: "form-signatures-signature",
    path: "signatures/:signature()",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/form/signatures/[signature].vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/index.vue")
  },
  {
    name: mails9X_teBnemeUxaFtFZeYJfKbBWZCSuIPHTJEyWb3dWFUMeta?.name,
    path: "/mails",
    meta: mails9X_teBnemeUxaFtFZeYJfKbBWZCSuIPHTJEyWb3dWFUMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/mails.vue"),
    children: [
  {
    name: "mails-id",
    path: ":id()",
    meta: { ...(_91id_93h0KBx44d3Uz8aHvi6Nq2fVg0qci3Yfaf_P_s5GS5sI4Meta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/mails/[id].vue"),
    children: [
  {
    name: "mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/mails/[id]/mailBaseData.vue")
  },
  {
    name: "mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/mails/[id]/mailActivities.vue")
  }
]
  },
  {
    name: "mails",
    path: "",
    meta: { ...(indexwhRCpMD5vVa47pjvCRb92JEJ_DB9NY1ZHd9VdxOl7xkMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/mails/index.vue")
  }
]
  },
  {
    name: eventsWS_JVNdfJM89Z5rpGhcBYPMlazf1kuatRuUkMIugqqoMeta?.name,
    path: "/events",
    meta: eventsWS_JVNdfJM89Z5rpGhcBYPMlazf1kuatRuUkMIugqqoMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events.vue"),
    children: [
  {
    name: "events-id",
    path: ":id()",
    meta: _91id_93Aa6dFG6NbYU11F5DTUIgpkwZa_SFq0zlBFOiLhqRPk8Meta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[id].vue"),
    children: [
  {
    name: "events-id-eventMails",
    path: "eventMails",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[id]/eventMails.vue")
  },
  {
    name: "events-id-eventLeaders",
    path: "eventLeaders",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[id]/eventLeaders.vue")
  },
  {
    name: "events-id-eventBaseData",
    path: "eventBaseData",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[id]/eventBaseData.vue")
  },
  {
    name: "events-id-eventQuestions",
    path: "eventQuestions",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[id]/eventQuestions.vue")
  },
  {
    name: "events-id-eventActivities",
    path: "eventActivities",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[id]/eventActivities.vue")
  },
  {
    name: "events-id-eventParticipants",
    path: "eventParticipants",
    meta: eventParticipantsvFzOlyjOCN_ZmTyk5L_45Ioh8bwhhWQypnGydIxMDNbNwMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[id]/eventParticipants.vue")
  },
  {
    name: "events-id-eventCrisisManagers",
    path: "eventCrisisManagers",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[id]/eventCrisisManagers.vue")
  },
  {
    name: "events-id-eventParticipantGroups",
    path: "eventParticipantGroups",
    meta: eventParticipantGroupsICZSUS9M82WBhIb6OwbucDMQosueYJCdulwVh5C3nEQMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[id]/eventParticipantGroups.vue")
  },
  {
    name: "events-id-eventTemporaryAccesses",
    path: "eventTemporaryAccesses",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[id]/eventTemporaryAccesses.vue")
  }
]
  },
  {
    name: "events",
    path: "",
    meta: { ...(indexCinxI_IFPgDsusm9rxv2_OL6d7cecTLtmxHdYQmdZC0Meta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/index.vue")
  },
  {
    name: "events-event-participants-id",
    path: ":event()/participants/:id()",
    meta: _91id_93C_45UwS_45QpaOpS5ruAwkOQ3gAN5todyQRgOM1__k806HYMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participants/[id].vue"),
    children: [
  {
    name: "events-event-participants-id-participantMails",
    path: "participantMails",
    meta: participantMailst4pqzITy6I_5cTSYTml_458XRYwTZDqqJa1vFoZaRVj7YMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participants/[id]/participantMails.vue")
  },
  {
    name: "events-event-participants-id-participantAnswers",
    path: "participantAnswers",
    meta: participantAnswersuY4UR3DoA7Z2kxo6_45lgMtQmrR3FAUEQ0REatx78x01QMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participants/[id]/participantAnswers.vue")
  },
  {
    name: "events-event-participants-id-participantBaseData",
    path: "participantBaseData",
    meta: participantBaseData8oZGmdQK6mUP71_D5LsHWQJNYcYGwm7iHISB5GmBCdgMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participants/[id]/participantBaseData.vue")
  },
  {
    name: "events-event-participants-id-participantGuardians",
    path: "participantGuardians",
    meta: participantGuardians_45qKpvKzat05OyDyEUv2miOpZZ0Cb8UFVQ7fbx4DHzwcMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participants/[id]/participantGuardians.vue")
  },
  {
    name: "events-event-participants-id-participantActivities",
    path: "participantActivities",
    meta: participantActivitiesGnrwkcieb7wVMrrtDEu7whxcK5rCPOHdbWkz_45g0YNskMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participants/[id]/participantActivities.vue")
  },
  {
    name: "events-event-participants-id-participantSubmissions",
    path: "participantSubmissions",
    meta: participantSubmissionsey_2Fd6Us2_lWy_45s3mkZATPPSEqLCVuIFBCtqV9qGHMMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participants/[id]/participantSubmissions.vue")
  },
  {
    name: "events-event-participants-id-participantEmergencyContacts",
    path: "participantEmergencyContacts",
    meta: participantEmergencyContactsKI_45DfplerAWx9Tzbh6rb7QE6R8WeNowThz3E0m02scMMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participants/[id]/participantEmergencyContacts.vue")
  },
  {
    name: "events-event-participants-id-participantTemporaryAccesses",
    path: "participantTemporaryAccesses",
    meta: participantTemporaryAccessesL_6sL817xdTq3F3Uciw7zKg0Se5b1DE5AZyT_JC9GPIMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participants/[id]/participantTemporaryAccesses.vue")
  }
]
  },
  {
    name: "events-event-participantGroups-id",
    path: ":event()/participantGroups/:id()",
    meta: _91id_937RZ3iDQaj1k_uiQJWzMdFPNBYPAEjfoomOsYNqgudBUMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participantGroups/[id].vue"),
    children: [
  {
    name: "events-event-participantGroups-id-groupBaseData",
    path: "groupBaseData",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participantGroups/[id]/groupBaseData.vue")
  },
  {
    name: "events-event-participantGroups-id-groupActivities",
    path: "groupActivities",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participantGroups/[id]/groupActivities.vue")
  },
  {
    name: "events-event-participantGroups-id-groupParticipants",
    path: "groupParticipants",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participantGroups/[id]/groupParticipants.vue")
  },
  {
    name: "events-event-participantGroups-id-groupTemporaryAccesses",
    path: "groupTemporaryAccesses",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/events/[event]/participantGroups/[id]/groupTemporaryAccesses.vue")
  }
]
  }
]
  },
  {
    name: "system",
    path: "/system",
    meta: systemHkGss_8Z2maJ_H3XrR9rLyCNPDEiBF7ylQgT6OQ_djoMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system.vue"),
    children: [
  {
    name: "system-roles",
    path: "roles",
    meta: rolesfoIZ5Lvz8TBOVgTpMe5Au53ezlvvXXSDbslIMiWtzmQMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/roles.vue")
  },
  {
    name: usersxg8V9_45UsQhpGN_2hlCE34uew2Ah5XsYrhP75Tss0HOQMeta?.name,
    path: "users",
    meta: usersxg8V9_45UsQhpGN_2hlCE34uew2Ah5XsYrhP75Tss0HOQMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/users.vue"),
    children: [
  {
    name: "system-users-id",
    path: ":id()",
    meta: { ...(_91id_93g97BpepD1PWrXBOfHmruPH81zvq9_45SaKJjU_45Z_95toEMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/users/[id].vue"),
    children: [
  {
    name: "system-users-id-userBaseData",
    path: "userBaseData",
    meta: userBaseDataXwkaA_USTQTxF44xpbefSE9mnkhyty6k0KrSLZ9uwB8Meta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/users/[id]/userBaseData.vue")
  },
  {
    name: "system-users-id-userActivities",
    path: "userActivities",
    meta: userActivitiesJOgqa4HJdcTlvmBkWqZgE92dp5bM2DDtP21OFn0dK9EMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/users/[id]/userActivities.vue")
  }
]
  },
  {
    name: "system-users",
    path: "",
    meta: { ...(indexSrs1oj0emoDJCn5ZFoZhdXDVfHiJolTJUetQKC_dJtoMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/users/index.vue")
  }
]
  },
  {
    name: "system-baseData",
    path: "baseData",
    meta: baseDataouC2dnUzBJY5WmXKEoMPMpT0xKjPKx35BWpMi0xKwCMMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/baseData.vue")
  },
  {
    name: "system-billings",
    path: "billings",
    meta: billingsIA3M6pHZNZn8f44h04mZe5MdrK1QppqTZBKfWE8HAh4Meta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/billings.vue")
  },
  {
    name: "system-billingRuns",
    path: "billingRuns",
    meta: billingRunsBY3p7Ll4qV8R1jI1BNK4yOb97FwQI_45OQoOKbpU2gFNUMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/billingRuns.vue")
  },
  {
    name: organisationskDkHrQTunIxU77IzsB4UwyQs8_45eUgIDUuauUcLq_GUwMeta?.name,
    path: "organisations",
    meta: organisationskDkHrQTunIxU77IzsB4UwyQs8_45eUgIDUuauUcLq_GUwMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/organisations.vue"),
    children: [
  {
    name: "system-organisations-id",
    path: ":id()",
    meta: { ...(_91id_93LlfFDe1ptFgM4E5QCz2Dq9nu5tUmsNd2I81Eb2BuqRwMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/organisations/[id].vue"),
    children: [
  {
    name: "system-organisations-id-organisationUsers",
    path: "organisationUsers",
    meta: organisationUsersbOrxhVIPob_aFpsvgulYVCKILfcnZitClVdxr4fxZ7EMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/organisations/[id]/organisationUsers.vue")
  },
  {
    name: "system-organisations-id-organisationPackage",
    path: "organisationPackage",
    meta: organisationPackagevA2EINXMiBprP_IXGmNn46vpEVvpGZeWbl5jVp3Bel4Meta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/organisations/[id]/organisationPackage.vue")
  },
  {
    name: "system-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    meta: organisationBaseData7vZIZ8JJmUR4dkfEN67i1ujZFISpUukVC7e_45cCduVu8Meta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "system-organisations-id-organisationActivities",
    path: "organisationActivities",
    meta: organisationActivitiesnlaqAM8Stl_45BW8DVA_45p_gMv6SwFRLgRUKE_45TseCqRCsMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "system-organisations-id-organisationSystemData",
    path: "organisationSystemData",
    meta: organisationSystemDataWso4al8BR5z7D__5RZhFV9eiWY71uTBuCmjmwdINk1AMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/organisations/[id]/organisationSystemData.vue")
  },
  {
    name: "system-organisations-id-organisationMailSettings",
    path: "organisationMailSettings",
    meta: organisationMailSettingsM5K70V1Af1ny_4519m9XV_g_45Q0TYekVcElwd7ljCJIu28Meta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/organisations/[id]/organisationMailSettings.vue")
  }
]
  },
  {
    name: "system-organisations",
    path: "",
    meta: { ...(indexClf5sIz13x0aSTIIkoBkWVVJEdeP3CSyAR5C9z4XrEwMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/organisations/index.vue")
  }
]
  },
  {
    name: "system-poolQuestions",
    path: "poolQuestions",
    meta: poolQuestionsiPG3tquUoCkrI2KlqLCQXp3bAqHys5mojweukAAyaYwMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/poolQuestions.vue")
  },
  {
    name: "system-mailTemplates",
    path: "mailTemplates",
    meta: { ...(indexqK6oROgny9hkkAFA60vK2hIxzC4E7Ciy7Wok5DI3BWUMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/mailTemplates/index.vue")
  },
  {
    name: "system-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplates/:id()/mailTemplateBaseData",
    meta: { ...(mailTemplateBaseData_izV5GAQNCMSByBLMrd7dmeu2Dg57k6PGGIqT1aoF_IMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/system/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingsH8KIscjpvt2T7HxSNXXzVujpyTkZRatKhxUUF1SMXmYMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings.vue"),
    children: [
  {
    name: "settings-internal",
    path: "internal",
    meta: internal4cZpUHzvJxQ1QnKvClDPCp8KkBVNmapmnj1nwEF4_isMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/internal.vue"),
    children: [
  {
    name: "settings-internal-users-id",
    path: "users/:id()",
    meta: { ...(_91id_93u_45XDWqUymO3KftVmRhtAQJbmOMMjD_45Wf775QD7guuoAMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/internal/users/[id].vue"),
    children: [
  {
    name: "settings-internal-users-id-userBaseData",
    path: "userBaseData",
    meta: userBaseDatawV_45c_45V3XQUkYA3wEbBpCzPIik_45y5BJZINLQrBtnh_CYMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/internal/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-internal-users-id-userActivities",
    path: "userActivities",
    meta: userActivities1yKzGJ2yHI8Cmr5l1BF6euI_45G94PAZmWvIRpO2TSbOEMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/internal/users/[id]/userActivities.vue")
  }
]
  },
  {
    name: "settings-internal-organisation",
    path: "organisation",
    meta: { ...(organisationgcIEUVnTxeI24Rzsn26b0A_d__45grPunUiSaFnE0WaHMMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/internal/organisation.vue"),
    children: [
  {
    name: "settings-internal-organisation-organisationUsers",
    path: "organisationUsers",
    meta: organisationUsersbEhyzK_r5KhfhhO2mUqaIlmPruzOuAFSLHO24cdR8LEMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/internal/organisation/organisationUsers.vue")
  },
  {
    name: "settings-internal-organisation-organisationPackage",
    path: "organisationPackage",
    meta: organisationPackageiviq7YpeuFkrP_ol6AxGjzWvz3WCd2lRWzFcZDxYiiAMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/internal/organisation/organisationPackage.vue")
  },
  {
    name: "settings-internal-organisation-organisationBaseData",
    path: "organisationBaseData",
    meta: organisationBaseDataGuBDXHtWOzl8dX1nh3_45lgurh2l5vwWOLO0j6tSb2FjEMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/internal/organisation/organisationBaseData.vue")
  },
  {
    name: "settings-internal-organisation-organisationMailSettings",
    path: "organisationMailSettings",
    meta: organisationMailSettingsbUK_45eWJmoXVvg9jHWCqb114JOI6uYxg5cFNzr_vxXycMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/internal/organisation/organisationMailSettings.vue")
  }
]
  },
  {
    name: "settings-internal-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplates/:id()/mailTemplateBaseData",
    meta: { ...(mailTemplateBaseDataCeXLyW_45NxrXD7XOZ_45Uv_45Ku3Iz4Rz2HGL35EXJfuTKM8Meta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/internal/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "settings-crisisManagers-id",
    path: "crisisManagers/:id()",
    meta: { ...(_91id_93FCbHSe5lt35_doU6LLP71hfnkUdi9OVGgO2_UZFVLhoMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/crisisManagers/[id].vue")
  },
  {
    name: "settings-loginProviders-id",
    path: "loginProviders/:id()",
    meta: { ...(_91id_93QDgw6nuTk1LGmqe1GSwC5EU0TEnZFvjbsg6fbhL_45rXYMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/loginProviders/[id].vue")
  },
  {
    name: "settings-crisisManagers",
    path: "crisisManagers",
    meta: { ...(index8ewOnFHS00ycc65MMvZuuuriZwiTdEHFbiVFt9dvq1MMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/crisisManagers/index.vue")
  },
  {
    name: "settings-loginProviders",
    path: "loginProviders",
    meta: { ...(indexoWv8BNoDqjoi0f_45fEANzdnMgizdhMFdbbgNUOHTWF3gMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: "questions",
    path: "/questions",
    meta: questions_45DPl2G_ZzIWj2sRS0oMIBZOESq6UaFJGGctgicXpwSYMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/questions.vue"),
    children: [
  {
    name: setseJzChSrn3LGQ1obkYSxplG30aPMjOSeMZJ_45hB5lecKMMeta?.name,
    path: "sets",
    meta: setseJzChSrn3LGQ1obkYSxplG30aPMjOSeMZJ_45hB5lecKMMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/questions/sets.vue"),
    children: [
  {
    name: "questions-sets-id",
    path: ":id()",
    meta: { ...(_91id_93U03W3O8IRR4S4sr205VYRHG9J8_eRUyQzB9BWzp98oMMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/questions/sets/[id].vue"),
    children: [
  {
    name: "questions-sets-id-setBaseData",
    path: "setBaseData",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/questions/sets/[id]/setBaseData.vue")
  }
]
  },
  {
    name: "questions-sets",
    path: "",
    meta: { ...(index59jvQsuM3mFm4LWbojMciI_bXyAB4EhS3I5v_zGKoHkMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/questions/sets/index.vue")
  }
]
  }
]
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexeOowH_45K0IANkZeEcD0nWra_2fwEN6i9mOFqZtidNE1oMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/auth/index.vue")
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/secret/index/inputs.vue")
  },
  {
    name: "secret-index-mosaic",
    path: "mosaic",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/secret/index/mosaic.vue")
  },
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-components",
    path: "components",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/secret/index/components.vue")
  }
]
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: registergtRqRIkUSdVcKoPp7NUZbUfRTLT7xr_7HnzHgJ8NGoAMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/auth/register.vue")
  },
  {
    name: "external-event",
    path: "/external/event",
    meta: event1HWwsAsfHKoRZRt12JHR0JwM6PfCa8fKa0wBqdWMEGQMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/external/event.vue"),
    children: [
  {
    name: "external-event-event",
    path: ":event()",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/external/event/[event].vue"),
    children: [
  {
    name: "external-event-event-leader-leader",
    path: "leader/:leader()",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/external/event/[event]/leader/[leader].vue")
  },
  {
    name: "external-event-event-emergency-emergency",
    path: "emergency/:emergency()",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/external/event/[event]/emergency/[emergency].vue")
  },
  {
    name: "external-event-event-temporary-temporary",
    path: "temporary/:temporary()",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/external/event/[event]/temporary/[temporary].vue")
  }
]
  }
]
  },
  {
    name: "auth-amos-organisation",
    path: "/auth/amos/:organisation()",
    meta: indexmCLC7o4U2PDdYUM0Jt83OnP_p_45NdGLVubeaczmT4k6MMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/auth/amos/[organisation]/index.vue")
  },
  {
    name: "auth-social-organisation",
    path: "/auth/social/:organisation()",
    meta: indexID7Ov186M9RDby8IfXZZN0CmKnnjdTkb1hfOS1sO0HIMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/pages/auth/social/[organisation]/index.vue")
  }
]